import { EntityRef } from '../../components/EntityRef';
import { useLabels, type OrderLabelInput } from '../../lib/labels';
import { paths, type ToneMap } from './shared';

/** Commerce vocabularies (labels come from the commerce namespace). */
export const ORDER_TONES: ToneMap = { PLACED: 'pending', FUNDS_RESERVED: 'pending', FULFILLING: 'pending', COMPLETED: 'ok', PARTIALLY_COMPLETED: 'warn', FAILED: 'crit', CANCELLED: 'neutral' };
export const PAYMENT_TONES: ToneMap = { INITIATED: 'neutral', PENDING: 'pending', SUCCEEDED: 'ok', FAILED: 'crit', UNKNOWN: 'serious', CANCELLED: 'neutral' };
export const ACCOUNT_TONES: ToneMap = { OPEN: 'ok', FROZEN: 'warn', CLOSED: 'neutral' };
export const DOC_TONES: ToneMap = { INVOICE: 'info', CREDIT_NOTE: 'warn' };

/**
 * Link to an order, named like everywhere else in the console (`orderLabel`: first domain,
 * "+N" for the others, placing date). UUIDs never stand in for a name.
 */
export function OrderRef({ id, order }: { id: string; order: OrderLabelInput }) {
  const L = useLabels();
  return <EntityRef to={paths.order(id)} id={id} label={L.order(order)} />;
}
